import { WebsiteType } from '@/consts';
import cn from '@/utils/cn';

import { useLingui } from '@lingui/react';
import dayjs from 'dayjs';

const Footer = ({
  variant = WebsiteType.HELPFIND,
}: {
  variant?: WebsiteType;
}) => {
  const { i18n } = useLingui();

  return (
    <footer
      id="footer"
      tabIndex={-1}
      className={cn(
        'bg-oxford-blue-400 text-gray-100',
        variant === WebsiteType.DEEPRY && 'bg-dark-gray-700'
      )}
    >
      <nav
        className={cn(
          'mx-auto flex max-w-[1112px] flex-col justify-between gap-y-[14px] py-8 md:flex-row md:py-10',
          'sm:max-w-screen-sm md:max-w-tablet lg:max-w-[980px]',
          'px-5 sm:px-7 md:px-10 lg:px-10'
        )}
      >
        <div
          role="contentinfo"
          className="body flex justify-center text-gray-400 lg:text-sm lg:leading-[20px]"
        >
          {variant === WebsiteType.DEEPRY
            ? i18n.t('Deepdry')
            : i18n.t('Helpfind Odszkodowania')}{' '}
          © {dayjs().year()}
        </div>
        <ul>
          <li className="flex justify-center">
            <a
              href={
                variant === WebsiteType.DEEPRY
                  ? 'https://deepdry.pl/polityka-prywatnosci'
                  : 'https://helpfind.pl/polityka-prywatnosci'
              }
              target="blank"
              rel="nofollow"
              className="body text-gray-400 transition-colors hover:text-primary lg:text-sm lg:leading-[20px]"
            >
              {i18n.t('Polityka prywatności')}
            </a>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
